import React, { useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import helpMeEvents from "@analytics/productActions/helpme";
import {
  // helpMeFloaterClicked as helpMeFloaterIsClicked,
  viewAutoCopliotChatbotLoaded,
  helpMePopupLoaded as helpMePopupIsLoaded,
  helpMeFormSubmitted as helpMeFormIsSubmitted
} from "segments/eventActions/common/callBackModule";
import { getHelpData } from "@utils/getHelpData";
import { useRouter } from "next/router";
import Context from "@components/useContext/context";

const Chatbot = ({ showChatbot }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { query } = router || {};
  const { isDesktop } = useContext(Context);

  const { helpData } = getHelpData({
    query,
    pathname: router.pathname,
    isMobile: !isDesktop
  });

  const {
    registeredMobileNumber,
    proposalMobileNumber,
    // mobileVerified,
    isRenewal
  } = useSelector(({ indexReducer, proposalDataReducer }: any) => ({
    registeredMobileNumber: indexReducer?.mobileNumber,
    proposalMobileNumber: proposalDataReducer?.data?.mobileNumber,
    // mobileVerified: proposalDataReducer?.data?.mobileVerified,
    isRenewal: proposalDataReducer?.data?.isRenewal
  }));

  const {
    helpMePopupLoaded,
    helpMeFormSubmitted
    // helpMeFloaterClicked
  } = helpMeEvents;

  const { screen } = helpData;
  const help_source = "chatbot";

  const copilotEventHandler = (e: any) => {
    switch (e?.data?.event) {
      case "copilot-iframe-loaded":
        dispatch(
          viewAutoCopliotChatbotLoaded({
            screen: screen,
            help_source,
            widget_type: help_source
          })
        );
        break;

      case "copilot-agent-callback-init":
        break;

      case "copilot-agent-callback-success":
        dispatch(
          helpMeFormIsSubmitted({
            screen: screen,
            phone: e.data.payload.phoneNumber,
            widget_type: help_source,
            language: e.data.payload?.preferred_language
          })
        );
        dispatch(
          helpMeFormSubmitted({
            edata: isRenewal
              ? {
                  screen: screen,
                  phone: e?.data?.payload?.phoneNumber,
                  language: e?.data?.payload?.preferred_language,
                  help_source,
                  techinfo: true
                }
              : {
                  screen: screen,
                  phone: e?.data?.payload?.phoneNumber,
                  language: e?.data?.payload?.preferred_language,
                  help_source
                },
            odata: {
              phone:
                proposalMobileNumber ||
                registeredMobileNumber ||
                e?.data?.payload?.phoneNumber
            }
          })
        );
        break;

      case "copilot-iframe-open":
        dispatch(
          helpMePopupLoaded({
            edata: {
              screen: screen,
              help_source
            }
          })
        );
        dispatch(
          helpMePopupIsLoaded({
            screen: screen,
            help_source,
            widget_type: help_source
          })
        );
        break;

      case "copilot-iframe-close":
        break;

      default:
    }
  };

  useEffect(() => {
    if (!showChatbot) return;
    window.addEventListener("message", copilotEventHandler);
    return () => {
      window.removeEventListener("message", copilotEventHandler);
    };
  }, [showChatbot]);

  return <acko-copilot hostname="" journey="auto" />;
};

export default Chatbot;
